import { render, staticRenderFns } from "./privacy3.vue?vue&type=template&id=06ca5e86&scoped=true"
import script from "./privacy3.vue?vue&type=script&lang=js"
export * from "./privacy3.vue?vue&type=script&lang=js"
import style0 from "./privacy3.vue?vue&type=style&index=0&id=06ca5e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca5e86",
  null
  
)

export default component.exports